var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    viewBox: "0 0 17 17",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    filterUnits: "userSpaceOnUse",
    height: 17,
    width: 17,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f14836",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "composite"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    result: "blend"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 8.5a8.5 8.5 0 1 1 -8.5-8.5 8.5 8.5 0 0 1 8.5 8.5zm-8.5-5.526a5.525 5.525 0 1 0 5.525 5.526 5.525 5.525 0 0 0 -5.525-5.526z",
    fill: "#fff",
    fillRule: "evenodd",
    filter: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/shape-5.732d1914b9a5d4725ded83105170ee6c.svg";
export { ForwardRef as ReactComponent };